<template>
    <form enctype="multipart/form-data">
        <div class="form-row">
            <label for="image-file">Image</label>
            <div class="input-group">
                <input type="file" id="image-file" class="custom-file-input" accept=".png,.jpg,.jpeg" :disabled="loading" @change="processFile($event)">
                <label class="custom-file-label">{{ filename }}</label>
            </div>
            <div class="form-group w-100">
                <label for="name">Name</label>
                <input type="text" id="name" class="form-control d-inline" :disabled="loading" v-model="name">
            </div>
        </div>
        <div class="d-flex justify-content-between align-items-center">
            <span class="mr-2">Tags:</span>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="cbAlert" :disabled="loading" v-model="tags.alert">
                <label class="form-check-label" for="cbAlert">Alert</label>
            </div>
            <div class="form-check form-check-inline">
                <input class="form-check-input" type="checkbox" id="cbAnnouncement" :disabled="loading" v-model="tags.announcement">
                <label class="form-check-label" for="cbAnnouncement">Announcement</label>
            </div>
            <button type="button" class="btn btn-small btn-secondary ml-auto" :disabled="loading" @click="handleUpload">
                Upload
                <span v-if="loading" class="spinner-border spinner-border-sm"></span>
            </button>
        </div>
    </form>
</template>

<script>
export default {
    props: {
        callback: Function
    },
    data() {
        return {
            name: '',
            file: null,
            tags: {
                alert: true,
                announcement: true,
            },
            filename: '',
            loading: false
        }
    },
    methods: {
        processFile(event) {
            this.filename = event.target.files[0].name
            this.file = event.target.files[0]
        },
        handleUpload() {
            this.loading = true
            const validResolutions = ['1920x1080', '2560x1440']
            const reader = new FileReader()
            const context = this

            reader.onload = function (e) {
                const image = new Image()
                image.src = e.target.result

                image.onload = function () {
                    const height = this.height
                    const width = this.width
                    const resolution = `${width}x${height}`
                    if(validResolutions.includes(resolution)) {
                        context.callback({
                            file: context.file,
                            name: context.name,
                            tags: context.tags
                        })
                        .then(() => context.loading = false)
                    } else {
                        alert("Image resolution must be '1920x1080' or '2560x1440'")
                        context.loading = false
                    }
                }
            }

            if(!this.file) {
                this.loading = false
                alert("File not selected")
                return
            }
            
            reader.readAsDataURL(this.file)
        }
    }
}
</script>